// extracted by mini-css-extract-plugin
module.exports = {"comboHeader":"styles_comboHeader__Rhc4i"};